import React, { Fragment, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getModelId, getDeviceByModelNumber } from "../../action/addvcModel";
import { setAlert } from "../../action/alert";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import { Link } from "react-router-dom";
import Spinner from "../layout/Spinner";
import Moment from "react-moment";
import { useNavigate, useLocation } from "react-router-dom";
import customConfig from "../../config";
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/ArrowDownward';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { getFreqToPower } from "../../action/report";
import { selectMenuProps } from "../../utils/selectMenuProps";
import "../Common/searchFilterLayout.css";
import "./DeviceDetails.css";

const SearchModel = ({
  getModelId,
  getDeviceByModelNumber,
  ModelData: { ModelData, loading },
  match,
  roles,
  wrapperClass,
  getFreqToPower,
  freqToPowerData
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { modelNum } = useParams();
  const [text, setText] = useState("");
  const [showText, setShowText] = useState(false);
  const [searchBy, setSearchBy] = useState(
    modelNum ? "modelNumber" : "modelId"
  );

  useEffect(() => {
    if (modelNum) {
      ModelData = {};
      getDeviceByModelNumber(modelNum);
      setShowText(true);
      setText("");
    }
  }, []);

  const onSubmit = (e) => {
    ModelData = {};
    setShowText(true);
    e.preventDefault();
    if (searchBy === "modelId") {
      getModelId(text);
    } else {
      getDeviceByModelNumber(text);
    }
    getFreqToPower({searchBy, text})
    setText("");
  };

  const onChange = (e) => setText(e.target.value);

  const changeSearchBy = (e) => {
    setSearchBy(e.target.value);
    ModelData = {};
    setShowText(false);
  };

  const downloadDeviceMetadata = () => {
    const blob = new Blob([JSON.stringify(ModelData)], { type: "text/json" });
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = `Device Model Data- ${ModelData.modelNumber}.json`;
    a.click();
  }

  if (loading) {
    return <Spinner />;
  }
  return (
    <Fragment>
      <ResponsiveContentWrapper className={wrapperClass || ""}>
        <div className={`search-device-page-container ${wrapperClass || ""}`}>
        <div className="container">

          {
            roles.includes(customConfig.roleProductManager) && <Link to="/addNewDeviceModel">
              <button className="btn btn-style-2 orange-bg mb-15">
                Add New Device Model
              </button>
            </Link>
          }


          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className="content-block bottom-shadow mb-0 search-filter-block search-filter-united-field">
          <div className="row">
            <div className="s12 col no-side-padding">
              <div className="content-block bottom-shadow mb-0">
                <div className="p-15">
                  <div className="search-filter-filter">
                    <div className="search-filter-title">
                      <span className="black-text font-600">Search Device Model</span>
                    </div>
                    <div className="search-filter-controls">
                    <span className="search-filter-search-by">Search By</span>
                    <FormControl variant="outlined" size="small" className="search-filter-type-select">
                      <Select
                        name="searchBy"
                        value={searchBy}
                        onChange={(e) => changeSearchBy(e)}
                        MenuProps={selectMenuProps}
                      >
                        <MenuItem value="modelId">Model Id</MenuItem>
                        <MenuItem value="modelNumber">Model Number</MenuItem>
                      </Select>
                    </FormControl>
                    <form className="search-filter-form" onSubmit={onSubmit}>
                      <div className="search-filter-input-wrap">
                        <div className="search-device not-found right">
                          <i className="material-icons search-icon"> search</i>
                          <input
                            className="add-input md border-0"
                            placeholder={
                              searchBy === "modelId"
                                ? "Enter Model Id"
                                : "Enter Model Number"
                            }
                            type="text"
                            name="text"
                            value={text}
                            onChange={onChange}
                          />
                        </div>
                      </div>
                      <div className="search-filter-btn">
                        <input
                          type="submit"
                          value="Search"
                          className="btn orange-bg btn-block md no-shadow"
                        />
                      </div>
                    </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            </div>
            </Grid>
          </Grid>
          <div className="mid-seprator"></div>
          <Alert />
        </div>
        <div>
        {showText && Object.keys(ModelData).length > 0 && (
          // <ResponsiveContentWrapper
          //   style={{ marginTop: "0px", paddingTop: "0px" }}
          //   className={wrapperClass || ""}
          // >
            <div className="container">
              <div className="device-detail-wrap device-info">
                <div className="row mb-0">
                  <div className="s12 p-0 col">
                    <div className="content-block position-relative">
                      {location?.state &&
                        location?.state?.showBackButton && (
                          <div className="btnPosition">
                            <button
                              className="btn btn-style-2 orange-bg"
                              style={{ marginRight: "12px" }}
                              onClick={() => {
                                if (location.state?.from) {
                                  navigate(location.state.from, {
                                    state: { from: "/deviceDetail/model" },
                                  });
                                } else {
                                  navigate(-1); // fallback to browser back
                                }
                              }}
                            >
                              Back
                            </button>
                          </div>
                        )}

                      <div className="p-15">
                        <div className="hd-style-2">
                          <h5>
                            Device Information
                            <div style={{ float: "right" }}>
                              {
                                roles.includes(customConfig.roleProductManager) &&
                                customConfig.allowedDeviceModelCategories.includes(ModelData.category) &&
                                <Link
                                  to="/addNewDeviceModel"
                                  state={{
                                    editDeviceModel: true,
                                    deviceModelData: ModelData,
                                    freqToPowerData: freqToPowerData
                                  }}
                                >
                                  <button className="btn btn-style-2 orange-bg ml-15 mb-15">
                                    Edit
                                    <IconButton
                                      size="small"
                                      style={{ marginLeft: "4px", marginTop: "-5px", color: "#fff" }}
                                    >
                                      <EditIcon fontSize="inherit" />
                                    </IconButton>
                                  </button>
                                </Link>
                              }
                              <button
                                className="btn btn-style-2 orange-bg ml-15 mb-15"
                                onClick={() => {
                                  downloadDeviceMetadata()
                                }}
                              >
                                Download
                                <IconButton size="small" style={{ marginLeft: "4px", marginTop: "-5px", color: '#fff' }}>
                                  <DownloadIcon fontSize="inherit" />
                                </IconButton>
                              </button>
                            </div>
                          </h5>
                        </div>
                        <div className="device-detail user-information" style={{ width: "100%", minWidth: 0 }}>
                          <div className="row mb-0">
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Model ID</label>
                                  <div className="user-about medium">{ModelData.modelId}</div>
                                </div>
                              </div>
                            </div>
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Model Number</label>
                                  <div className="user-about medium">{ModelData.modelNumber}</div>
                                </div>
                              </div>
                            </div>
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Model Name</label>
                                  <div className="user-about medium">{ModelData.modelName}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-0">
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Category</label>
                                  <div className="user-about medium">{ModelData.category}</div>
                                </div>
                              </div>
                            </div>
                            {ModelData.subCategory && ModelData.subCategory.length != 0 && (
                              <div className="s4 col">
                                <div className="d-flex info-box">
                                  <div className="info">
                                    <label className="label">Sub Category</label>
                                    <div className="user-about medium">{ModelData.subCategory}</div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Launch Date</label>
                                  <div className="user-about medium">
                                    {Number.isInteger(ModelData.launchDate) && (
                                      <Moment format="MMMM Do YYYY, h:mm:ss a" date={ModelData.launchDate * 1000} />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">IsActive</label>
                                  <div className="user-about medium">{ModelData.isActive}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-0">
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Manufacturer</label>
                                  <div className="user-about medium">{ModelData.manufacturer}</div>
                                </div>
                              </div>
                            </div>
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Manufacturer Address</label>
                                  <div className="user-about medium">{ModelData.manufacturerAddress}</div>
                                </div>
                              </div>
                            </div>
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Product Manager ID</label>
                                  <div className="user-about medium">{ModelData.productManagerId}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-0">
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Version</label>
                                  <div className="user-about medium">{ModelData.version}</div>
                                </div>
                              </div>
                            </div>
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Help Doc URL</label>
                                  <div className="user-about medium">
                                    <a className="link-style" target="_blank" rel="noopener noreferrer" href={customConfig.supportURL}>
                                      {ModelData.helpDocUrl}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {(ModelData.category === customConfig.decviceCategoryAC || ModelData.category === customConfig.deviceCategoryCAC || ModelData.category === customConfig.deviceCategoryIAC) && ModelData.enrolementProfileId && (
                              <div className="s4 col">
                                <div className="d-flex info-box">
                                  <div className="info">
                                    <label className="label">Enrolment Profile ID</label>
                                    <div className="user-about medium">{ModelData.enrolementProfileId}</div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {(ModelData.category === customConfig.decviceCategoryAC || ModelData.category === customConfig.deviceCategoryCAC) && (
                              <div className="s4 col">
                                <div className="d-flex info-box">
                                  <div className="info">
                                    <label className="label">Tonnage</label>
                                    <div className="user-about medium">{ModelData.tonnage}</div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="row mb-0">
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Matter Enabled</label>
                                  <div className="user-about medium">{ModelData.isMatterEnabled == true ? "True" : "False"}</div>
                                </div>
                              </div>
                            </div>
                            <div className="s4 col">
                              <div className="d-flex info-box">
                                <div className="info">
                                  <label className="label">Chip Type</label>
                                  <div className="user-about medium">{ModelData.chipType}</div>
                                </div>
                              </div>
                            </div>
                            {ModelData.isMatterEnabled == true && (
                              <>
                                <div className="s4 col">
                                  <div className="d-flex info-box">
                                    <div className="info">
                                      <label className="label">Product ID</label>
                                      <div className="user-about medium">{ModelData.matterPID}</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="s4 col">
                                  <div className="d-flex info-box">
                                    <div className="info">
                                      <label className="label">Vendor ID</label>
                                      <div className="user-about medium">{ModelData.vendorId}</div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="reset-capabilities position-relative" style={{ width: "100%", minWidth: 0, overflowX: "auto" }}>
                          <div className="pb-10 pl-10 pt-10">
                            <label className="title" style={{ color: '#000' }}>Control Capability</label>
                          </div>

                          <div className="p-15">
                            <div className="device-detail">
                              <div className="row mb-0 gray-bdr">
                                <div className="s4 col">
                                  <div className="unique-box mb-15">
                                    <label className="title">Capability</label>
                                  </div>
                                </div>

                                <div className="s4 col">
                                  <div className="unique-box mb-15">
                                    <label className="title">
                                      Attribute Key
                                    </label>
                                  </div>
                                </div>

                                <div className="s4 col">
                                  <div className="unique-box mb-15">
                                    <label className="title">Values</label>
                                  </div>
                                </div>
                              </div>
                              {ModelData["controlCapabilities"] &&
                                ModelData["controlCapabilities"].map(
                                  (control, i) => (
                                    <div className="separator-light" key={i}>
                                      <div className="row" key={control?.capability + "row"}>
                                          <div className="s4 col">
                                            <div className="unique-box">
                                              <div className="device-info">
                                                {control?.capability}
                                              </div>
                                            </div>
                                          </div>
                                      {control.attributes &&
                                        control.attributes.map(
                                          (attribute, j) => (
                                            <>
                                              {j !==0?
                                              <div className="s4 col">
                                                <div className="unique-box">
                                                  <div className="device-info">
                                                  </div>
                                                </div>
                                              </div>
                                              :
                                              ""}

                                              <div className="s4 col">
                                                <div className="unique-box">
                                                  <div className="device-info">
                                                    {attribute.key}
                                                  </div>
                                                </div>
                                              </div>

                                              {attribute.values ? (
                                                <div className="s4 col">
                                                  <div className="unique-box">
                                                    <div className="device-info">
                                                      {Array.isArray(
                                                        attribute.values
                                                      )
                                                        ? attribute.values
                                                          .map((elem) => {
                                                            if (
                                                              typeof elem ===
                                                              "string"
                                                            ) {
                                                              return elem;
                                                            } else if (
                                                              Array.isArray(
                                                                elem
                                                              )
                                                            ) {
                                                              return elem.join(
                                                                ", "
                                                              );
                                                            } else {
                                                              let keys =
                                                                Object.keys(
                                                                  elem
                                                                );
                                                              return `${keys[0]
                                                                } : ${elem[keys[0]]
                                                                } (${elem[keys[1]]
                                                                })`;
                                                            }
                                                          })
                                                          .join(" / ")
                                                        : attribute.values}
                                                    </div>
                                                  </div>
                                                </div>
                                              ) :
                                                attribute.intValues ? (
                                                  <div className="s4 col">
                                                    <div className="unique-box">
                                                      <div className="device-info">
                                                        {Array.isArray(
                                                          attribute.intValues
                                                        )
                                                          ? attribute.intValues
                                                            .map((elem) => {
                                                              if (
                                                                typeof elem ===
                                                                "string" || typeof elem === "number"
                                                              ) {
                                                                return elem;
                                                              } else if (
                                                                Array.isArray(
                                                                  elem
                                                                )
                                                              ) {
                                                                return elem.join(
                                                                  ", "
                                                                );
                                                              } else {
                                                                let keys =
                                                                  Object.keys(
                                                                    elem
                                                                  );
                                                                return `${keys[0]
                                                                  } : ${elem[keys[0]]
                                                                  } (${elem[keys[1]]
                                                                  })`;
                                                              }
                                                            })
                                                            .join(" / ")
                                                          : attribute.values}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) :
                                                  attribute.range ? (
                                                    <div className="s4 col">
                                                      <div className="unique-box">
                                                        <div className="device-info">
                                                          {Object.keys(
                                                            attribute.range
                                                          ).map((rangeKey, k) => (
                                                            <div key={k}>
                                                              <span className="gray-text">
                                                                {rangeKey}:
                                                              </span>
                                                              &nbsp;
                                                              {attribute.range[
                                                                rangeKey
                                                              ].map(
                                                                (rangeVal, l) =>
                                                                  `${l > 0
                                                                    ? " / "
                                                                    : ""
                                                                  }${rangeVal.value
                                                                  } ${rangeVal.unit
                                                                    ? rangeVal.unit
                                                                    : ""
                                                                  }`
                                                              )}
                                                              <br />
                                                            </div>
                                                          ))}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <div className="s4 col">
                                                      <div className="unique-box">
                                                        <div className="device-info">
                                                          N/A
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                            </>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="reset-capabilities position-relative" style={{ marginTop: "20px" }}>
                          <div className="pb-10 pl-10 pt-10">
                            <label className="title" style={{ color: '#000' }}>Status Capability</label>
                          </div>

                          <div className="p-15">
                            <div className="device-detail">
                              <div className="row mb-0 gray-bdr">
                                <div className="s4 col">
                                  <div className="unique-box mb-15">
                                    <label className="title">Capability</label>
                                  </div>
                                </div>
                              </div>
                              {ModelData["statusCapabilitiesV2"] &&
                                ModelData["statusCapabilitiesV2"].map(
                                  (status, i) => (
                                    <div className="separator-light" key={i}>
                                      <div className="row" key={i + 'row'}>
                                        <div className="s4 col">
                                          <div className="unique-box">
                                            <div className="device-info">
                                              {status.capability}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                        </div>

                        <span className=" top-right"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        )}
        </div>
        </div>
      </ResponsiveContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  ModelData: state.getModel,
  roles: state.auth.roles,
  freqToPowerData: state.report.freqToPowerData
});

export default connect(mapStateToProps, {
  setAlert,
  getModelId,
  getDeviceByModelNumber,
  getFreqToPower,
})(SearchModel);